import React from 'react';
import classNames from 'classnames';

const tags = [
  'Dedication',
  'Teamwork',
  'Communication',
  'Balance',
];

export default function TagSelector() {
  const [value, setValue] = React.useState([]);

  const handleTagSelect = (tag) => () => {
    const existing = value.indexOf(tag) > -1;
    if (!existing) setValue([...value, tag]);
    else setValue(value.filter((v) => (v !== tag)));
  };

  return (
    <div className="tag-selector">
      {
        tags.map((tag) => (
          <button
            type="button"
            className={classNames('tag-selector-tag', { active: value.indexOf(tag) > -1 })}
            onClick={handleTagSelect(tag)}
            key={tag}
          >
            {tag}
          </button>
        ))
      }
    </div>
  );
}
